import useUserTrackingEvent from "../../../analytics/useUserTrackingEvent";
import useUserTrackingErrorEvent from "../../../analytics/useUserTrackingErrorEvent";

export function useLoginEventTrackers() {
  const trackLogin = useUserTrackingEvent("user-login");
  const trackLoginError = useUserTrackingErrorEvent("login-error");
  return { trackLogin, trackLoginError };
}
